define([
    './InsuranceSuiteMetadataService',
    'l10nModule'
], (InsuranceSuiteMetadata)=> {
    return angular.module('edge.platform.metamirror', ['edge.platform.l10n'])
        .factory('InsuranceSuiteMetadata', InsuranceSuiteMetadata);
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/metamirror/module.js